import Carousel from "@Pages/mobileApp/features/bookingSection/components/Carousel";
import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";

const TravelingDotComBookingsCarousel = () => {
    const {
        one,
        two,
        three,
    } = useTranslation("mobile_app.carousel_section")

    const bookingInfoData = [
        {
            label: one.intro,
            title: one.title,
            content: one.description,
            imagePath: "images/mobile-app-landing-page/01_search_results",
            color: "purple",
            index: 0,
        },
        {
            label: two.intro,
            title: two.title,
            content: two.description,
            imagePath: "images/mobile-app-landing-page/02_detailed_route_info",
            color: "purple",
            index: 1,
        },
        {
            label: three.intro,
            title: three.title,
            content: three.description,
            imagePath: "images/mobile-app-landing-page/03_manage_bookings",
            color: "purple",
            index: 2,
        },
    ]

    return (
        <Carousel
            data={bookingInfoData}
        />
    )
}

export default TravelingDotComBookingsCarousel